


export function userStatus() {
    let currentStatus = {
        to_be_censored:"待审核",
        to_be_tested:"待测试",
        to_be_cooperated:"待合作",
        had_cooperated:"已合作",
        censor_refused:"审核不通过",
        test_refused:"测试不通过",
        cooperate_refused:"拒绝合作"
    }
    return currentStatus
}


export function jobStatus() {
    let currentStatus = {
        to_be_translate: "待指派译员",
        going_unified: "待统稿",
        accept_translate: "待译员接受",
        refused_translate: "译员已拒绝",
        going_translate: "待译员提交",
        to_be_review: "待指派译员",
        accept_review: "待译员接受",
        refused_review: "译员已拒绝",
        stopped: "终止",
        completed: "已完成",
        going_review: "待审校提交",
        to_be_censored: "待审核",
        failed: "已拒绝",
        quests_censored: "待审核",
        quests_working: "待提交",
        quests_failed: "任务失败",
        quests_pass: "任务完成",
    }
    return currentStatus
}
